import React, { useState } from 'react'
import Modal from '~/components/_layouts/Modal'

const ConfirmationModal = ({ open, onClose, onConfirm, title, message }) => {
  const [disabledButton, setDisabledButton] = useState(null)

  const handleConfirm = (e) => {
    setDisabledButton(true)
    if (onConfirm) onConfirm(e)
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      actions={[
        <button key="cancel" onClick={onClose} className="btn">
          Cancel
        </button>,
        <button
          key="confirm"
          onClick={handleConfirm}
          className="btn btn-primary"
          disabled={!!disabledButton}
        >
          Confirm
        </button>,
      ]}
      size="sm"
    >
      <div>{message}</div>
    </Modal>
  )
}

export default ConfirmationModal
